import { render, staticRenderFns } from "./MergeExistingSegments.vue?vue&type=template&id=09f47f2b&"
import script from "./MergeExistingSegments.vue?vue&type=script&lang=js&"
export * from "./MergeExistingSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports